
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 173 23"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M73 6.74h-8.91a1.45 1.45 0 00-1.37 1.32V1h-3.63v21h3.62V9.17v1.58a1.61 1.61 0 011.41-1.58h6.55A1.79 1.79 0 0172.28 11v11h3.62V9.94a3.06 3.06 0 00-2.9-3.2M27 6.09h-8.41c-1 .11-1.77.71-1.77 1.44 0-.73-.77-1.33-1.77-1.44H6a1.37 1.37 0 00-1.34 1.3V6.06H1v3a1.62 1.62 0 000 .24V22h3.63V10.38a1.78 1.78 0 011.6-1.86h5.86a1.75 1.75 0 011.5 1.59V22h3.67V10.12a1.75 1.75 0 011.51-1.59h5.85a1.78 1.78 0 011.6 1.86V22h3.62V9.32A3.06 3.06 0 0027 6.09M93.06 6.72H79.8v2.43h10.93A1.77 1.77 0 0192.34 11v1.75H82.23A3.06 3.06 0 0079.32 16v2.81A3.06 3.06 0 0082.23 22h9.07a1.42 1.42 0 001.17-1.3V22H96V9.94a3.06 3.06 0 00-2.91-3.21M92.34 18a1.62 1.62 0 01-1.44 1.58h-6.34A1.78 1.78 0 0183 17.69V17a1.78 1.78 0 011.61-1.86h7.78V18M33.26 1.08h3.62v2.53h-3.62zM33.26 6.72h3.62v15.29h-3.62zM154.31 1.08h3.62v2.53h-3.62zM161.34 1.07h3.62V22h-3.62zM40.3 9.92v8.83A3.07 3.07 0 0043.2 22h12.47v-2.47H45.54a1.78 1.78 0 01-1.61-1.86V11a1.78 1.78 0 011.61-1.86h10.13V6.71H43.2a3.06 3.06 0 00-2.9 3.21M109.81 15.17h6.06V9.96a3.07 3.07 0 00-2.91-3.22h-10.69a3.07 3.07 0 00-2.9 3.26v8.78a3.06 3.06 0 002.91 3.22h13.06v-2.48h-10.73a1.78 1.78 0 01-1.61-1.86v-2.48h6.81zM103 11a1.78 1.78 0 011.61-1.86h6a1.78 1.78 0 011.61 1.86v1.65H103zM168.38 1.07H172V22h-3.62zM154.31 6.72h3.62v15.29h-3.62zM119.27 1h3.62v20.97h-3.62zM148 6.74h-8.91a1.44 1.44 0 00-1.37 1.32V1h-3.63v21h3.63V10.75a1.61 1.61 0 011.41-1.58h6.55a1.78 1.78 0 011.6 1.86V22h3.63V9.94a3.06 3.06 0 00-2.91-3.2"}})])
          )
        }
      }
    